import React from 'react';
import './BackgroundSection.css';
import bg from '../assets/2.png';

const BackgroundSection = () => {
  return (
    <div
      className="background-section"
      style={{
        backgroundImage: `url(${bg})`,
      }}
    >
      <div className="text-content">
      <h1 className="tagline">
          Empowering Ideas with Cutting-Edge <br />
          <span className="highlight1">
             Tools, Extensions, and Solutions!
          </span>
        </h1>
        <div className="highlight-line"></div>
        <b><p className="descrition">
          Crafting innovative software, tools, and extensions to simplify workflows, empower businesses, and drive unparalleled growth and success.
        </p></b>
      </div>
    </div>
  );
};

export default BackgroundSection;
